import img from '../api/img.api'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  imgRepository: []
}

const pageSize = 12

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  addImgsList (state, imgList) {
    state.imgRepository = imgList
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  // retrieve all images, and store those in repository pages
  refreshAllThumbnails (context) {
    img.api.getAllThumbnails()
    .then(response => {
      context.commit('addImgsList', response.data['imgList'])
    },
    error => {
      console.log('error when trying to get images thumbnails' + error.text())
    })
  }
}
// getters are functions
const getters = {
  getAllThumbnails: state => {
    return state.imgRepository
  },
  getPageCount: state => {
    return Math.ceil(state.imgRepository.length / pageSize)
  },
  getThumbnailPage: (state, getters) => (page) => {
    let pagemax = Math.ceil(state.imgRepository.length % pageSize)
    // si on demande une page trop grande
    if (page > pagemax) {
      page = pagemax
    }

    // si on demande la première page
    if (page === 0) {
      let ret = state.imgRepository.slice(0, pageSize)
      return ret
    } else {
      let startIndex = (page - 1) * pageSize
      let stopIndex = Math.min(state.imgRepository.length, (page * pageSize))
      return state.imgRepository.slice(startIndex, stopIndex)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/imgs.js